<script>
    import utilsService from '@/services/core/utils.service';

    export default {
        props: {
            modelValue: null,
            options: {
                type: Array,
                default: () => []
            },
            valueField: {
                type: String,
                default: 'value'
            },
            textField: {
                type: String,
                default: 'text'
            },
            disabled: Boolean,
            required: Boolean,
            size: String,
            optionsField: {
                type: String,
                default: 'options'
            }
        },
        emits: ['update:modelValue', 'change'],
        computed: {
            guid() {
                return `form-select-${utilsService.uuid()}`;
            },
            getOptions() {
                return this.options?.map(op => {
                    if (typeof op === 'string') return { [this.valueField]: op, [this.textField]: op };

                    if (op[this.optionsField]?.length > 0)
                        return {
                            ...op,
                            [this.optionsField]: op[this.optionsField].map(o =>
                                typeof o === 'string' ? { [this.valueField]: o, [this.textField]: o } : o
                            )
                        };

                    return op;
                });
            },
            getSizeClass() {
                switch (this.size) {
                    case 'sm':
                        return 'form-select-sm';
                    case 'lg':
                        return 'form-select-lg';
                    default:
                        return '';
                }
            }
        },
        methods: {
            onChange(e) {
                const { value } = e.target || {};
                this.$emit('update:modelValue', value);
                this.$nextTick(() => this.$emit('change', value));
            }
        }
    };
</script>

<template>
    <select
        class="gsb-form-select form-select"
        :class="getSizeClass"
        :id="guid"
        :disabled="disabled"
        :required="required"
        :value="modelValue == null ? '' : modelValue"
        @change="e => onChange(e)"
    >
        <template v-for="(option, index) in getOptions">
            <optgroup v-if="(option[optionsField] || []).length > 0" :key="`form-select-optgroup-${index}`" :label="option[textField]">
                <option
                    v-for="(op, j) in option[optionsField]"
                    :key="`form-select-option-${index}-${j}`"
                    :value="op[valueField] == null ? '' : op[valueField]"
                >
                    {{ op[textField] }}
                </option>
            </optgroup>

            <option v-else :key="`form-select-option-${index}`" :value="option[valueField] == null ? '' : option[valueField]">
                {{ option[textField] }}
            </option>
        </template>
    </select>
</template>

<style lang="scss">
    .gsb-form-select {
        &:not(:disabled) {
            cursor: pointer;
        }

        &.form-select-sm {
            height: 2.4rem;
            padding: 0 0.5rem;
            font-size: 1.3rem;
        }

        &.form-select-lg {
            height: 2.5rem;
            padding: 0.5rem 1rem;
            font-size: 2rem;
            line-height: 1.5;
        }
    }
</style>
